import React, { useContext, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { ThemeProvider } from '../contexts/ThemeContext';
import { ThemeContext } from '../contexts/ThemeContext';

function Navbar() {
  const { theme, toggleTheme } = useContext(ThemeContext);

  useEffect(() => {
    // Import Bootstrap JavaScript
    const bootstrapScript = document.createElement('script');
    bootstrapScript.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js';
    bootstrapScript.integrity = 'sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz';
    bootstrapScript.crossOrigin = 'anonymous';
    document.body.appendChild(bootstrapScript);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(bootstrapScript);
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">
        <NavLink className="navbar-brand" to="/">
          <img
            src="/my-logo.png"
            alt="Code-E Project Logo"
            style={{ height: '40px' }}
          />
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink className="nav-link" to="/">Home</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/html">HTML</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/css">CSS</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/javascript">JavaScript</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/bootstrap">Bootstrap</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/vscode">VS Code</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/mongodb">MongoDB</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/inspiration">Inspiration</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/about">About</NavLink>
            </li>
          </ul>
          <div className="theme-switch-wrapper">
            <label className="theme-switch" htmlFor="themeSwitch">
              <input
                type="checkbox"
                id="themeSwitch"
                checked={theme === 'dark'}
                onChange={toggleTheme}
              />
              <div className="slider round">
                <span className="mode-label">{theme === 'light' ? '☀️' : '🌙'}</span>
              </div>
            </label>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;